import { ReactNode } from 'react';
import { styled } from './styles';

const StyledWrapper = styled('section', {
  maxWidth: '1710px',
  padding: '0 40px',
  margin: '0 auto',
  position: 'relative',
  '@toXL': {
    maxWidth: '1225px'
  },
  '@toTablet': {
    padding: '0 20px 0 20px'
  }
});

export const Wrapper = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <StyledWrapper className={className}>{children}</StyledWrapper>;
};
